import { render } from "./CreateQueue.vue?vue&type=template&id=253b44e8"
import script from "./CreateQueue.vue?vue&type=script&lang=js"
export * from "./CreateQueue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__